import { createFileRoute } from "@tanstack/react-router";
import { VehiclesPage } from "@/features/vehicles/pages/vehicles-page";

export const Route = createFileRoute("/_authenticated/vehicles/")({
	component: VehiclesPage,
});
